import React from "react";
import "./styles/PageThree.css";

import Shield from "../assets/shield.png";
import Audience from "../assets/audience.png";
import MobileImage from "../assets/mobile-image-group.png";
import DesktopImage from "../assets/desktop-image-group.png";
import Sparkles from "../assets/sparkles.png";

const PageThree = () => {
  return (
    <section className="page-three landing-page-padding">
      <div className="page-wrapper">
        <div className="flex-row">
          <div className="page-three-column-one">
            <div className="section-heading">
              <h1 className="text-heading text-dark-blue">
                Build your Trading Bot
              </h1>
              <p className="text-paragraph">
                Confused about where to start? TradingView has a learning curve
                that we can help you master. Start small with{" "}
                <span className="text-faded-blue">indicators</span>, then
                level-up to <span className="text-green">strategies</span>.
              </p>
            </div>
            <img
              className="mobile-image"
              src={MobileImage}
              alt="graph mobile"
            />

            <div className="sub-heading">
              <img src={Shield} />
              <div className="sub-heading-content">
                <h2>Alerts on chart indicators</h2>
                <p className="text-paragraph">
                  Easily utilize common indicators like MACD, RSI, and simple
                  Moving Average.
                </p>
              </div>
            </div>
            <div className="sub-heading">
              <img src={Audience} />
              <div className="sub-heading-content">
                <h2>Alerts on chart indicators</h2>
                <p className="text-paragraph">
                  Easily utilize common indicators like MACD, RSI, and simple
                  Moving Average.
                </p>
              </div>
            </div>
          </div>

          <div className="page-three-column-two">
            <img
              className="desktop-image"
              src={DesktopImage}
              alt="graph desktop"
            />
            <img className="sparkles" src={Sparkles} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageThree;
